import React from 'react';

const ThemeParkIcon = (props) => {
  return (
    <img
      alt="Park rozrywki"
      src="/static/images/icons/tourist_attractions/theme_park.svg"
      {...props}
    />
  );
};

export default ThemeParkIcon;
